export default "__VITE_ASSET__fN3GBDImFL4syCUWbqabiA__"